import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

/**
 * OTPField Component
 * @param {Object} props
 * @param {number} props.length 
 * @param {Array<string>} props.values 
 * @param {function} props.onChange 
 * @param {boolean} [props.disabled] 
 */
const OTPField = ({ length = 6, values, onChange, disabled = false }) => {
  const inputRefs = useRef(Array.from({ length }, () => React.createRef()));
  const [focusedIndex, setFocusedIndex] = useState(null);

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    if (/^\d?$/.test(value)) {
      const updatedValues = [...values];
      updatedValues[index] = value;
      onChange(updatedValues);

      if (value && index < length - 1) {
        inputRefs.current[index + 1].current.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const updatedValues = [...values];
      if (!values[index] && index > 0) {
        updatedValues[index - 1] = "";
        inputRefs.current[index - 1].current.focus();
      } else {
        updatedValues[index] = "";
      }
      onChange(updatedValues);
    }
  };

  return (
    <div className="otp-field d-flex flex-row gap-3">
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          ref={inputRefs.current[index]}
          type="text"
          className="otp-input w-100 text-center rounded-1 py-3 px-0 px-md-3"
          value={values[index] || ""}
          maxLength="1"
          onChange={(e) => handleInputChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          disabled={disabled}
          placeholder={focusedIndex === index ? "" : "0"}
          onFocus={() => setFocusedIndex(index)}
          onBlur={() => setFocusedIndex(null)}
        />
      ))}
    </div>
  );
};

OTPField.propTypes = {
  length: PropTypes.number,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default OTPField;
